import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { MdNotificationsActive, MdLogout } from "react-icons/md";
import Logo from "../images/logo-knust.png";
import { NavLink } from "react-router-dom";
import socketIOClient from "socket.io-client";
const ENDPOINT = process.env.REACT_APP_API_URL;

export default function Navbar(props) {
	// const [setIsLoading] = useState(false);
	const [notification, setNotification] = useState(0);
	const handleLogOut = () => {
		// setIsLoading(true);
		console.log("logging out");
		// const timer = setTimeout(() => {
		localStorage.removeItem("dumb");
		localStorage.removeItem("user");
		localStorage.removeItem("id");
		localStorage.removeItem("jwt");
		// }, 5000);

		// clearTimeout(timer);
		window.location.assign("/admin/login");
		// setIsLoading(false);
	};
	useEffect(() => {
		const socket = socketIOClient(ENDPOINT);
		socket.on("sent", (data) => {
			setNotification((s) => s + 1);
		});

		// socket.emit("sent", "hi");
	}, []);
	const { isDrawerOpen, func } = props;
	return (
		<>
			<nav>
				<div className="d-nav-flex">
					<ul>
						<li>
							<NavLink to="/admin/dashboard">
								<img
									className="dash-logo"
									src={Logo}
									alt="..."
									style={{ width: 40, height: 50 }}
								/>
							</NavLink>
						</li>
						<li>
							<FaBars
								size={25}
								color="var(--darkBlue)"
								style={{ marginRight: 18 }}
								className="FaBars-display"
								onClick={() => func(!isDrawerOpen)}
							/>
						</li>
					</ul>
					<ul className="d-nav-inline-flex">
						<li>
							<MdNotificationsActive
								className="notification"
								size={30}
								title=" Current Messsages"
								color="var(--darkBlue)"
							></MdNotificationsActive>
							<span className="badge">{notification && notification}</span>
						</li>
						<li>
							<MdLogout
								className="logout-icon"
								title="Logout"
								size={30}
								onClick={() => handleLogOut()}
								color="var(--darkBlue)"
							/>
						</li>
					</ul>
				</div>
			</nav>
		</>
	);
}
